(function () {
	angular.module('trackeye')
		.constant('cacheConfig', {
			address: {
				maxAge: 15 * 60 * 1000,     // 15 minutes
				mode: 'memory'
			},
			device: {
				maxAge: 60 * 60 * 1000,     // 60 minutes
				mode: 'memory'
			},
			token: {
				maxAge: 10 * 60 * 60 * 1000,// 10 hours
				mode: 'sessionStorage'
			},
			modelfeature: {
				maxAge: 24 * 60 * 60 * 1000, // 24 hours
				mode: 'memory'
			},
			configurations: {
				maxAge: 24 * 60 * 60 * 1000, // 24 hours
				mode: 'memory'
			},
			model: {
				maxAge: 24 * 60 * 60 * 1000, // 24 hours
				mode: 'localStorage'
			}
		});
})();